import APIService from './APIService';

export default {
  getPhpConfig() {
    return APIService.apiCall().get('server-config/php');
  }
}